import React, { Component } from 'react';
import Leftbar from '../components/Leftbar';
import Gallery from '../components/Gallery';

class Comic extends Component {
    render() {
        return (
            <>
                <Leftbar />
                <div className="container">
                    <div className="row justify-content-md-center align-items-center">
                        <Gallery />
                    </div>
                </div>
            </>
        );
    }
}

export default Comic;